// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"229":"0d3f0940","810":"5d6a4e31"}[chunkId] + ".css";
};